module.exports = __webpack_public_path__ + "static/media/calendar-check.6b87ae48.svg";